export function initMap() {
  let contentString = '';

  const setContentString = (item) => `
        <div class="google-map-item">
          <address><strong>${item.custom.name}</strong><br/>
          ${item.custom.address}</address>

          <p>
            <a class="toast-directions-link" href="${item.custom.googleMapsUrl}" target="_blank" aria-label="Get Directions (Google Maps), opens in new tab, window">Get Directions (Google Maps) <i class="far fa-external-link-alt" aria-hidden="true"></i></a>
            <a class="toast-details-link" href="${item.custom.url}" aria-label="${item.custom.name} location details">Location Details</a>
          </p>

        </div>`;

  const onMarkerClick = (marker) => {
    contentString = setContentString(marker);
    window.infoWindow.setContent(contentString);
    window.infoWindow.open(window.mapInstance, marker);
  };

  const deleteMarkers = () => {
    if (window.mapMarkers) {
      for (let i = 0; i < window.mapMarkers.length; i++) {
        window.mapMarkers[i].setMap(null);
      }
    }
    window.mapMarkers = [];
  };

  const setMarkers = () => {
    deleteMarkers();
    const latlngbounds = new window.google.maps.LatLngBounds();

    window.locations.forEach(function (item, index) {
      const myLatLng = new window.google.maps.LatLng(item.lat, item.long);
      latlngbounds.extend(myLatLng);

      const marker = new window.google.maps.Marker({
        position: myLatLng,
        map: window.mapInstance,
        custom: {
          name: item.name,
          address: item.address,
          phone: item.phone,
          url: item.url,
          googleMapsUrl: item.googleMapsUrl,
          index: index + 1
        },
      });

      window.google.maps.event.addListener(marker, 'click', function () {
        onMarkerClick(marker);
      });

      window.mapMarkers.push(marker);
    });

    window.mapInstance.fitBounds(latlngbounds);
  };

  const initialize = () => {
    if (typeof window.locations === 'undefined') return;
    window.mapInstance = new window.google.maps.Map(document.getElementById('map'), {
      zoom: 10,
      maxZoom: 15
    });

    window.infoWindow = new window.google.maps.InfoWindow({
      content: contentString,
      minWidth: 240,
      maxWidth: 330,
    });

    window.google.maps.event.addListener(window.mapInstance, 'click', function () {
      window.infoWindow.close();
    });

    setMarkers();
  };

  if (window.google && window.locations) {
    if (!window.mapInstance) {
      window.google.maps.event.addDomListener(window, 'load', initialize);
    } else {
      setMarkers();
    }
  }
};
initMap();
export { initMap as default };
